import { useCallback, useEffect, useState } from 'react';
import { Observable } from '@serviceos-rn/core';
const heightMapObs = new Observable({});
const heightObs = new Observable(0);
heightMapObs.subscribe(value => {
    heightObs.next(Object.values(value).sort((a, b) => b - a)[0] || 0);
});
export function useTipHeight(route) {
    const [height, setHeight] = useState(heightObs.value);
    useEffect(() => {
        const sub = heightObs.subscribe(setHeight);
        return () => {
            sub.unsubscribe();
            route && heightMapObs.update({ [route]: 0 });
        };
    }, []);
    useEffect(() => {
        return () => {
            route && heightMapObs.update({ [route]: 0 });
        };
    }, [route]);
    const handleHeight = useCallback((value) => {
        route && heightMapObs.update({ [route]: value });
    }, [route]);
    return [height, handleHeight];
}
